import { Container } from "components";
import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import {
  loadCaptchaEnginge,
  validateCaptcha,
} from "react-simple-captcha";
import api from "services/api";
import ContactUsForm from "components/contactUsForm";
import { toast } from "react-toastify";

const initialValues = {
  name: "",
  phone_no: "",
  org_name: "",
  email: "",
  subject: "",
  call_back: "",
  description: "",
  attach_file: "",
  enquiry_type: "",
  // captcha: "", // Add this line
};

const validationSchema = Yup.object({
  name: Yup.string()
    .required("Required")
    .matches(/^[a-zA-Z ]*$/, "Name can only contain letters and spaces"),
  phone_no: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
    .required("Required"),
  org_name: Yup.string(),
  email: Yup.string().email("Invalid email format").required("Required"),
  subject: Yup.string().required("Required"),
  enquiry_type: Yup.string().required("Required"),
  description: Yup.string().required("Required"),
  call_back: Yup.string().required("Required"),
  // attach_file: Yup.mixed(),
  // captcha: Yup.string().required("CAPTCHA is required"), // Add this line
});

export const Contactus = () => {
  const [userCaptcha, setUserCaptcha] = useState("");
  const attchRef = useRef();

  useEffect(() => {
    loadCaptchaEnginge(6);
  }, []);
  const handleRefreshCaptcha = () => {
    loadCaptchaEnginge(6);
  };
  const handleAttchFile = (e, setFieldValue) => {
    const file = e.target.files[0];
    const validTypes = ["image/jpeg", "image/png", "image/gif"];
    const maxSizeInBytes = 800 * 1024;

    if (file) {
      if (!validTypes.includes(file.type)) {
        toast.error("Only JPG,GIF,or PNG files are allowed");
        setFieldValue("attach_file", "");
        attchRef.current.value = null;
        return;
      }
      if (file.size > maxSizeInBytes) {
        toast.error("File size should not exceed 800KB.");
        setFieldValue("attach_file", "");
        attchRef.current.value = null;

        return;
      }

      setFieldValue("attach_file", file);
    } else {
      setFieldValue("attach_file", "");
    }
  };
  const hadleSubmit = async (values, resetForm) => {
    if (!userCaptcha) {
      toast.error("Please enter captcha");
      return;
    }
    if (!validateCaptcha(userCaptcha)) {
      toast.error("Invalid CAPTCHA. Please try again.");
      return;
    }
    if (!values.attach_file) {
      values.attach_file = "";
    }
    const formData = new FormData();

    for (const key in values) {
      formData.append(key, values[key]);
    }
    try {
      const response = await api.post("/contact-us", formData);
      attchRef.current.value = null;
      resetForm();
      setUserCaptcha("");
      console.log("fetContactUs :", response);
      toast.success(response?.data?.message);
    } catch (error) {
      console.log("fetContactUs Error:", error);
      toast.error(error?.response?.data?.message || "error");
    }
  };
  return (
    <Container>
      <div className="content-wraper">
        <div class="container-xxl flex-grow-1 container-p-y">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <Link to="#">Help</Link>
              </li>
              <li class="breadcrumb-item active">Contact us</li>
            </ol>
          </nav>
        <ContactUsForm/>
        </div>
      </div>
    </Container>
  );
};
